document.addEventListener('DOMContentLoaded', () => {
  const agreementCheckbox = document.querySelector('[data-agreement-check]');
  const pharmacistCheckbox = document.querySelector('[data-pharmacist-check]');
  const submitBtn = document.querySelector('button[type="submit"][data-submit-btn]');

  agreementCheckbox.addEventListener('change', (e) => {
    submitBtn.disabled = !(pharmacistCheckbox.checked) || !(agreementCheckbox.checked);
  });
  pharmacistCheckbox.addEventListener('change', (e) => {
    submitBtn.disabled = !(pharmacistCheckbox.checked) || !(agreementCheckbox.checked);
  });

  const registrationForm = document.querySelector('.js-m3RegistrationForm');
  registrationForm.addEventListener('submit', (e) => {
    e.preventDefault();
    // NOTE: 二重送信対策
    //       送信後10秒経ってもページが変わらなかったら再度押せるようにする
    submitBtn.disabled = true;
    setTimeout(() => {
      submitBtn.disabled = false;
    }, 10 * 1000);
    grecaptcha.enterprise.ready(async () => {
      const siteKey = window.RECAPTCHA.key
      const actionName = window.RECAPTCHA.action
      const token = await grecaptcha.enterprise.execute(
        siteKey, { action: actionName }
      );
      const recaptchaHiddenField = document.querySelector('[data-recaptcha-token]');
      recaptchaHiddenField.value = token;
      const removeBeforeunloadDialogEvent = new Event('removeBeforeunloadDialog');
      document.dispatchEvent(removeBeforeunloadDialogEvent)

      registrationForm.submit();
    });
  });
});

// NOTE: 会員登録フォームは今後は独自で改修していく想定だが、
//       初期ローンチ時点では既存フォームとほぼ同じ仕様となるため、
//       一旦は2025.8現在の以下のjsをatlasからそのままコピーしている
//         - s.m3img.com/atlas/1.0.0/javascripts/registration.min.js
// TODO: atlasからそのままコピーした経緯からjQueryを使用かつes6未使用
//       少しずつ書き換えたい
(function($){
  function generateSetupName(endpoint, maxLength, target, errors, showMaxLengthErrMsg, hideErrMsgs, showInvalidErrMsgs){
    return function(){
      $(target).blur(function () {
        var v = $(this).val();

        $(errors).hide();

        if (v.length > maxLength) {
          showMaxLengthErrMsg();
        } else if (v.length >= 1) {
          $.ajax({
            type: 'GET',
            cache: false,
            url: endpoint + encodeURIComponent(v),
            success: hideErrMsgs,
            error: showInvalidErrMsgs
          });
        } else {
          hideErrMsgs();
        }
      });
    };
  }

  var setupLastName = generateSetupName(
    'https://www.m3.com/registration/checkLastNameTextV3?lastName=',
    9,
    '#m3_user-last-name',
    '#last-name-errors',
    function(){
      $('#last-name-max-length-message').show();
      $('#last-name-not-available-message').hide();
    },
    function() {
      $('#last-name-max-length-message').hide();
      $('#last-name-not-available-message').hide();
    },
    function() {
      $('#last-name-max-length-message').hide();
      $('#last-name-not-available-message').show();
    }
  );

  var setupFirstName = generateSetupName(
    'https://www.m3.com/registration/checkFirstNameTextV3?firstName=',
    9,
    '#m3_user-first-name',
    '#first-name-errors',
    function(){
      $('#first-name-max-length-message').show();
      $('#first-name-not-available-message').hide();
    },
    function(){
      $('#first-name-max-length-message').hide();
      $('#first-name-not-available-message').hide();
    },
    function(){
      $('#first-name-max-length-message').hide();
      $('#first-name-not-available-message').show();
    }
  );

  var setupLastNameKana = generateSetupName(
    'https://www.m3.com/registration/checkLastNameKanaTextV3?lastNameKana=',
    15,
    '#m3_user-last-name-kana',
    '#last-name-kana-errors',
    function(){
      $('#last-name-kana-max-length-message').show();
      $('#last-name-kana-not-available-message').hide();
    },
    function(){
      $('#last-name-kana-max-length-message').hide();
      $('#last-name-kana-not-available-message').hide();
    },
    function(){
      $('#last-name-kana-max-length-message').hide();
      $('#last-name-kana-not-available-message').show();
    }
  );

  var setupFirstNameKana = generateSetupName(
    'https://www.m3.com/registration/checkFirstNameKanaTextV3?firstNameKana=',
    15,
    '#m3_user-first-name-kana',
    '#first-name-kana-errors',
    function(){
      $('#first-name-kana-max-length-message').show();
      $('#first-name-kana-not-available-message').hide();
    },
    function(){
      $('#first-name-kana-max-length-message').hide();
      $('#first-name-kana-not-available-message').hide();
    },
    function(){
      $('#first-name-kana-max-length-message').hide();
      $('#first-name-kana-not-available-message').show();
    }
  );

  function setupEmail() {
    $('#m3_user-mail-address').blur(function() {
      var v = $(this).val().trim();

      $('#mail-address-errors').hide();
      if (v.length > 64) {
        $('#mail-address-max-length').show();
        $('#mail-address-not-correct').hide();
      } else if (v.match(/^[\.\w\-+/]+@([A-Za-z0-9]\.|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9]\.)+[A-Za-z]+$/)) {
        $('#mail-address-max-length').hide();
        $('#mail-address-not-correct').hide();
      } else if (v.length == 0) {
        $('#mail-address-max-length').hide();
        $('#mail-address-not-correct').hide();
      } else {
        $('#mail-address-max-length').hide();
        $('#mail-address-not-correct').show();
      }

      if (v.match(/@docomo\.ne\.jp$/) || v.match(/@softbank\.ne\.jp$/) ||
          v.match(/\.vodafone\.ne\.jp$/) || v.match(/@ezweb\.ne\.jp$/) ) {
        $('#mail-address-mobile-mail').show();
      } else {
        $('#mail-address-mobile-mail').hide();
      }
    });
  }

  $(document).ready(function(){
    setupEmail();
    setupLastName();
    setupFirstName();
    setupLastNameKana();
    setupFirstNameKana();

  });
})(jQuery);
